import QRCode from "qrcode";

export const generateQRCode = async (data: string): Promise<string> => {
  return await QRCode.toDataURL(data, {
    errorCorrectionLevel: "L",
    type: "image/png",
    width: 120,
    margin: 1,
  });
};

export const generateQRCodeAsImageData = async (data: string): Promise<Uint8Array> => {
  // Use toDataURL instead of toBuffer for better webpack compatibility
  // Reduced size from 200px to 120px and error correction from M to L for faster generation and smaller file size
  const dataURL = await QRCode.toDataURL(data, {
    errorCorrectionLevel: "L",
    type: "image/png",
    width: 120,
    margin: 1,
  });

  // Convert data URL to Uint8Array
  const base64Data = dataURL.split(",")[1] ?? "";
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i); // NOSONAR: charCodeAt is correct for binary data conversion (0-255), codePointAt would be wrong for multi-byte Unicode
  }
  return bytes;
};
